module.exports = __webpack_public_path__ + "static/img/1200px-User_font_awesome.5172ccf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1200px-User_font_awesome.png
// module id = Q+al
// module chunks = 1